import React, { useState } from 'react';
import axios from 'axios';
import { FaFilePowerpoint, FaFileAlt, FaTrash } from 'react-icons/fa';
import { BACKEND_URL } from '../Constants';

const getFileTypeIcon = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  if (ext === 'ppt' || ext === 'pptx') return <FaFilePowerpoint size={48} color="#d24726" />;
  return <FaFileAlt size={48} color="#555" />;
};

const MediaGrid = ({ files, setFiles }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({ type: '', url: '', name: '' });

  const handleFileClick = (file) => {
    const ext = file.name.split('.').pop().toLowerCase();
    const fileUrl = file.url?.startsWith('http')
      ? file.url
      : `${BACKEND_URL}${file.url}`;

    if (['ppt', 'pptx'].includes(ext)) {
      setModalContent({
        type: 'powerpoint',
        url: `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`,
        name: file.originalName || file.name,
      });
    } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
      setModalContent({ type: 'image', url: fileUrl, name: file.originalName || file.name });
    } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
      setModalContent({ type: 'video', url: fileUrl, name: file.originalName || file.name });
    } else {
      window.open(fileUrl, '_blank');
      return;
    }

    setModalVisible(true);
  };

  const handleDelete = async (fileId) => {
    if (!window.confirm('Are you sure you want to delete this file?')) return;

    try {
      await axios.delete(`${BACKEND_URL}/api/media/${fileId}`);
      setFiles((prev) => prev.filter((f) => f._id !== fileId));
    } catch (err) {
      console.error('Delete failed:', err);
      alert('Failed to delete file.');
    }
  };

  return (
    <>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: '1.5rem',
        padding: '1rem',
      }}>
        {files.map((file) => {
          const ext = file.name.split('.').pop().toLowerCase();
          const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
          const fileUrl = file.url?.startsWith('http')
            ? file.url
            : `${BACKEND_URL}${file.url}`;

          return (
            <div key={file._id || file.name} style={{
              background: '#fff',
              borderRadius: '10px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              padding: '1rem',
              textAlign: 'center',
              transition: 'transform 0.2s',
              cursor: 'pointer',
              position: 'relative',
            }}
              onClick={() => handleFileClick(file)}
            >
              {isImage ? (
                <img
                  src={fileUrl}
                  alt={file.name}
                  style={{
                    width: '100%',
                    height: '120px',
                    objectFit: 'cover',
                    borderRadius: '6px',
                    marginBottom: '0.5rem',
                  }}
                />
              ) : (
                <div style={{ marginBottom: '0.5rem' }}>
                  {getFileTypeIcon(file.name)}
                </div>
              )}
              <p style={{
                fontSize: '0.85rem',
                color: '#333',
                wordBreak: 'break-word',
                margin: 0,
              }}>{file.originalName || file.name}</p>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(file._id);
                }}
                style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  background: 'transparent',
                  border: 'none',
                  color: '#c00',
                  fontSize: '1.2rem',
                  cursor: 'pointer',
                }}
                title="Delete file"
              >
                <FaTrash />
              </button>
            </div>
          );
        })}
      </div>

      {/* Modal Viewer */}
      {modalVisible && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            maxWidth: '900px',
            width: '100%',
            padding: '1rem',
            position: 'relative',
          }}>
            <button
              onClick={() => setModalVisible(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'transparent',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
              }}
            >
              &times;
            </button>

            <h5 style={{ marginBottom: '1rem', textAlign: 'center' }}>{modalContent.name}</h5>

            {modalContent.type === 'powerpoint' && (
              <iframe
                src={modalContent.url}
                width="100%"
                height="600px"
                frameBorder="0"
                title="PowerPoint Viewer"
                style={{ borderRadius: '6px' }}
              ></iframe>
            )}

            {modalContent.type === 'image' && (
              <img
                src={modalContent.url}
                alt="Preview"
                style={{ width: '100%', borderRadius: '6px' }}
              />
            )}

            {modalContent.type === 'video' && (
              <video
                src={modalContent.url}
                controls
                style={{ width: '100%', borderRadius: '6px' }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MediaGrid;